

import {WeaLocaleProvider} from 'ecCom';
const getLabel = WeaLocaleProvider.getLabel;
//获取柱状图option
function getBarOption(xAxisData, series = [], title = '', subTitle = '', showLegend='1'){
    series = series.map(item => {
        item.itemStyle = {
            normal: {
                label: {
                    show: true,//是否展示
                    position: 'top'
                } ,
            },
        }
        return item;
    })
    let legendData = series.map(item=>{
        item.type = 'bar';
        return item.name;
    });
    let option = {
        title: {
            text: title,
            subtext: subTitle
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            show: showLegend == '1',
            data: legendData
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        yAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        xAxis: {
            type: 'category',
            data: xAxisData
        },
        series: series
    }
    return option;
}

//获取柱状图option
function getBar3dOption(xAxisData, series, title = '', subTitle = '', showLegend='1'){
    let dimensions = ['xName'];
    let source = [];
    let encode = {x:'xName'};
    let tooltip = [0];
    series.map((item, i)=>{
        if(i == 0 && !encode.y) encode.y = item.name;
        if(i == 1 && !encode.z) encode.z = item.name;
        tooltip.push(i+1);
        dimensions.push(item.name);
    });
    encode.tooltip = tooltip;
    xAxisData.map((xName, i)=>{
        let arr = [];
        arr.push(xAxisData[i]);
        series.map((item, j)=>{
            arr.push(item.data[i]);
        });
        source.push(arr);
    });
    let option = {
        grid3D: {},
        tooltip: {},
        xAxis3D: {
            type: 'category'
        },
        yAxis3D: {
            type: 'category'
        },
        zAxis3D: {},
        visualMap: {
            show: showLegend == '1',
            max: 1e8,
            dimension: 'Population'
        },
        dataset: {
            dimensions,
            source
        },
        series: [
            {
                type: 'bar3D',
                // symbolSize: symbolSize,
                shading: 'lambert',
                encode
            }
        ]
    };
    return option;
}
    
function getLineOption(xAxisData, series, title = '', subTitle = '', showLegend='1'){
    let legendData = series.map(item=>{
        item.type = 'line';
        return item.name;
    });
    let option = {
        title: {
            text: title
        },
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            show: showLegend == '1',
            data:legendData
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
        },
        yAxis: {
            type: 'value'
        },
        series: series 
    };
    return option;
}

function getAreaOption(xAxisData, series =  [], title = '', subTitle = '', showLegend='1'){
    let legendData = series.map(item=>{
        item.type = 'line';
        item.stack =  getLabel(388005,"总量");
        item.areaStyle = {normal: {}};
        return item.name;
    });
    let option = {
        title: {
            text: title
        },
        tooltip : {
            trigger: 'axis',
            axisPointer: {
                type: 'cross',
                label: {
                    backgroundColor: '#6a7985'
                }
            }
        },
        legend: {
            show: showLegend=='1',
            data: legendData
        },
        toolbox: {
            feature: {
                saveAsImage: {}
            }
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis : [
            {
                type : 'category',
                boundaryGap : false,
                data : xAxisData
            }
        ],
        yAxis : [
            {
                type : 'value'
            }
        ],
        series :series
    };
    return option;
}


function getBarGraphOption(xAxisData, series = [], title = '', subTitle = '', showLegend='1'){
    let legendData = series.map(item=>{
        item.type = 'bar';
        item.itemStyle = {
            normal: {
                label: {
                    show: true,//是否展示
                    position: 'right'
                } ,
            },
        }
        item.data = item.data.reverse();
        return item.name;
    });
    let option = {
        title: {
            text: title,
            subtext: subTitle
        },
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            show: showLegend=='1',
            data: legendData.reverse()
        },
        grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
            type: 'value',
            boundaryGap: [0, 0.01]
        },
        yAxis: {
            type: 'category',
            data: xAxisData.reverse()
        },
        series: series
    }
    return option;
}

function getPieOption(series = {}, title = '', subTitle = '', showLegend='1'){
    let data = [];
    let legendData = series.data.map(item=>{
        data.push({
            name: item[0],
            value: item[1]
        });
        return item[0];
    });
    let option = {
        title : {
            text: title,
            subtext: subTitle,
            x:'center'
        },
        tooltip : {
            trigger: 'item',
            formatter: "{b} : {d}%"
        },
        legend: {
            show: showLegend=='1',
            orient: 'vertical',
            left: 'left',
            data: legendData
        },
        series : [
            {
                type: 'pie',
                radius : '55%',
                center: ['50%', '60%'],
                data: data,
                itemStyle: {
                    emphasis: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    };
    return option;
}


function getCircleOption(series = {}, title = '', subTitle = '', showLegend='1'){
    let data = [];
    let legendData = series.data.map(item=>{
        data.push({
            name: item[0],
            value: item[1]
        });
        return item[0];
    });
    let option = {
        title : {
            text: title,
            subtext: subTitle,
            x:'center'
        },
        tooltip: {
            trigger: 'item',
            formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
            show: showLegend=='1',
            orient: 'vertical',
            x: 'left',
            data:legendData
        },
        series: [
            {
                type:'pie',
                radius: ['10%', '80%'],
                avoidLabelOverlap: false,
                label: {
                    normal: {
                        show: false,
                        position: 'center'
                    },
                    emphasis: {
                        show: false,
                        textStyle: {
                            fontSize: '30',
                            fontWeight: 'bold'
                        }
                    }
                },
                labelLine: {
                    normal: {
                        show: false
                    }
                },
                data:data
            }
        ]
    };
    return option;
}

function getGaugeOption(datas, title = '', subTitle = '', showLegend='1'){
    const { series } = datas;
    const { data } = series;
    const { startval, middleval, realval, endval } = data;
    const myIsNaN = (value, def = 0) => {
        value = Number(value);  
        if(typeof value === 'number' && isNaN(value)){
            return def;
        }
        return value; 
    }
    let option = {
        tooltip : {
            formatter: "{a} <br/>{c} {b}"
        },
        toolbox: {
            show: true,
            feature: {
                restore: {show: true},
                saveAsImage: {show: true}
            }
        },
        series : [
            {
                type: 'gauge',
                z: 3,
                min: myIsNaN(startval,0),
                max: myIsNaN(endval,1),
                splitNumber: 10,
                radius: '50%',
                axisLine: {            // 坐标轴线
                    lineStyle: {       // 属性lineStyle控制线条样式
                        width: 10
                    }
                },
                axisTick: {            // 坐标轴小标记
                    length: 15,        // 属性length控制线长
                    lineStyle: {       // 属性lineStyle控制线条样式
                        color: 'auto'
                    }
                },
                splitLine: {           // 分隔线
                    length: 20,         // 属性length控制线长
                    lineStyle: {       // 属性lineStyle（详见lineStyle）控制线条样式
                        color: 'auto'
                    }
                },
                axisLabel: {
                    backgroundColor: 'auto',
                    borderRadius: 2,
                    color: '#eee',
                    padding: 3,
                    textShadowBlur: 2,
                    textShadowOffsetX: 1,
                    textShadowOffsetY: 1,
                    textShadowColor: '#222'
                },
                title : {
                    // 其余属性默认使用全局文本样式，详见TEXTSTYLE
                    fontWeight: 'bolder',
                    fontSize: 20,
                    fontStyle: 'italic'
                },
                // data: [{value: myIsNaN(realval, 0), name: '完成率'}]
                data: [{value: myIsNaN(realval, 0)}]
            }
        ]
    };
    return option;
}



function getEChartOption(data){
    const { charttype, showLegend } = data;
    let { categories, dot, series, title, subTitle } = data;
    switch(charttype){
        case 'bar':
            return getBarOption(categories, series, title, subTitle, showLegend);
            break;
        case 'bar3d':
            return getBar3dOption(categories, series, title, subTitle, showLegend);
            break;
        case 'line':
            return getLineOption(categories, series, title, subTitle, showLegend);
            break; 
        case 'area':
            return getAreaOption(categories, series, title, subTitle, showLegend);
            break;
        case 'bar-graph':
            return getBarGraphOption(categories, series, title, subTitle, showLegend);
            break;
        case 'pie':
            return getPieOption(series, title, subTitle, showLegend);
            break;
        case 'circle':
            return getCircleOption(series, title, subTitle, showLegend);
            break;
        case 'gauge':
            return getGaugeOption(data, title, subTitle);
            break;
    }
}
export default getEChartOption;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal/elements/components/common/echart/options.js